import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_kids_new_products: FaireCategoryEntity = {
  token: "cat_kids-new-products",
  type: "category",
  name: "New products",
  level: 2,
  parentToken: "cat_kids-baby",
  href: "/category/kids-baby/new-products",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
